import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDialogComponent } from './custom-dialog.component';



@NgModule({
  declarations: [
    CustomDialogComponent,    
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    CustomDialogComponent,
  ],
  providers: [

  ]
})
export class CustomDialogModule { }
